export default function buildOnInputEventChange({ pipelineOutput, integrationOutput, serverResponse }) {
  return () => {
    pipelineOutput.reset();
    integrationOutput.reset();
    serverResponse.reset();
  };
}
